import React from "react";
import Slider from "react-slick";
import placeholder from "../../../../../images/bg.jpg";

const ScreenGallery = ({ pictures }) => {
  const imgs = Array.isArray(pictures) ? pictures.filter((p) => p && p.url) : [];

  if (imgs.length === 0) {
    return (
      <div className="screenGallery">
        <img className="screenGallery__img" src={placeholder} alt="" />
      </div>
    );
  }

  if (imgs.length === 1) {
    return (
      <div className="screenGallery">
        <img className="screenGallery__img" src={imgs[0].url} alt="" />
      </div>
    );
  }

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="screenGallery">
      <Slider {...settings}>
        {imgs.map((p) => (
          <div key={p.id}>
            <img className="screenGallery__img" src={p.url} alt="" />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ScreenGallery;
